<h5 class="mb-3">
  <strong>Basic</strong>
</h5>
<div class="mb-5">
  <nz-spin nzTip="Loading...">
    <nz-alert nzType="info" nzMessage="Informational Notes" nzCloseable
      nzDescription="Additional description and informations about copywriting." nzShowIcon>
    </nz-alert>
  </nz-spin>
</div>